export enum AwardType {
	Manual = 'manual',
	Claimable = 'claimable',
}
